module.exports = __webpack_public_path__ + "static/media/rooms-menu-icon.015afa05.svg";